import React from 'react';
import { Row, Col, FormGroup } from 'react-bootstrap';
import { SearchBox, Combo, TextBox, MaskedBox } from 'fw/forms';
import { Button } from 'fw/components';
import { SetupSearch } from 'areas/shared/pages/setup';
import * as API from 'modules/app/API';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { AnnualSalesCombo, EmployeesRangeCombo, StateMultiCombo, GeographicMarketCombo, BusinessOwnershipMultiCombo, NaicsCodeCategoryAuto, BusinessCertificationMultiCombo } from 'areas/shared/controls';

class Search extends SetupSearch {

    initialState() {
        return {
            list: [],
            loading: false
        };
    }

    initialForm() {
        return {
            name: "",
            nAICSCodes: [{ value: "", label: "" }],
            stateCodes: [],
            businessOwnershipIds: []
        };
    }

    getButtonMargin = () => {
        return -50;
    }

    ready = () => {
    }

    searchCompanyLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: {
                type: 'vob'
            }
        }
    }

    searchVeteranLoader = () => {
        return {
            url: API.Search.url('/suggest'),
            params: { type: 'vobOwner' }
        }
    }

    handleAddAnotherNAIC = (e) => {
        e.preventDefault();
        let form = this.state.form;
        form.nAICSCodes.push({ value: "", label: "" });
        this.setState({ form });
    }

    handleRemoveNAIC = (e, i) => {
        e.preventDefault();
        let form = this.state.form;
        form.nAICSCodes.splice(i, 1);
        this.setState({ form });
    }

    handleNAICChange = (item, index) => {
        let form = this.state.form;
        form.nAICSCodes[index] = item;
        this.setState({ form });
    }

    renderNAICs = () => {
        return this.state.form.nAICSCodes.map((item, index) => (
            <Row key={index} style={{ marginBottom: 5 }}>
                <Col xs={this.state.form.nAICSCodes.length === 1 ? 12 : 11}>
                    
                        <NaicsCodeCategoryAuto
                            value={item ? item.value : null}
                            text={item ? item.label : null}
                            placeholder='Search NAICS Code...'
                            onChange={e => this.handleNAICChange(e, index)}
                            maxLength={6}
                        />
                    
                </Col>
                {this.state.form.nAICSCodes.length > 1 ?
                    <Col xs={1} style={{ marginTop: 0, marginLeft: -15, paddingLeft: 0, textAlign: "left" }}>
						<Button type="button" bsStyle="link" onClick={(e) => this.handleRemoveNAIC(e, index)} title="Remove NAICS Code">
                            <FontAwesomeIcon icon={faTrashAlt} size="lg" color="black" />
						</Button>
                    </Col> : null
                }
            </Row>
        ));
    };

    renderForm() {
        return (
            <React.Fragment>
                <Row>
                    <Col md={3} style={{ paddingLeft: 5, paddingRight: 5 }}>
                        <FormGroup style={{ marginBottom: 5 }}>
                            <TextBox
                                name="keywords"
                                placeholder="Keyword Search"
                                maxLength={255}
                                ref={(c) => { this.focusControl = c }} />
                        </FormGroup>
                        <FormGroup style={{ marginBottom: 5 }}>
                            <SearchBox
                                name="vobName"
                                label="name"
                                placeholder="Company Name"
                                loader={this.searchCompanyLoader}
                                clearable />
                        </FormGroup>
                        <FormGroup style={{ marginBottom: 5 }}>
                            <TextBox
                                name="professionalAccreditation"
                                placeholder="Professional Accreditation" />
                        </FormGroup>
                        <FormGroup style={{ marginBottom: 5 }}>
                            <MaskedBox
                                name="vobFEIN"
                                placeholder="Company FEIN/EIN"
                                mask="999999999"
                                alwaysShowMask={false}
                                maskChar="" />
                        </FormGroup>
                    </Col>
                    <Col md={3} style={{ paddingLeft: 5, paddingRight: 5 }}>
                        <FormGroup style={{ marginBottom: 5 }}>
                            <SearchBox
                                name="veteranOwnerName"
                                label="veteranOwnerName"
                                placeholder="Veteran Name"
                                loader={this.searchVeteranLoader}
                                clearable />
                        </FormGroup>
                        <Row>
                            <Col md={12}>
                                {this.state.form.nAICSCodes != null && this.state.form.nAICSCodes.length > 0 && (
                                    <React.Fragment>
                                        {this.renderNAICs()}
                                    </React.Fragment>
                                )}
								<Button type="button" bsStyle="link" onClick={(e) => this.handleAddAnotherNAIC(e)}>
									Search for another NAICS Code
								</Button>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3}>
                        <Row>
                            <Col md={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <FormGroup style={{ marginBottom: 5 }}>
                                    <StateMultiCombo
                                        name="stateCodes"
                                        placeholder="State(s)"
                                        clearable />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <FormGroup style={{ marginBottom: 5 }}>
                                    <GeographicMarketCombo
                                        name="geographicalMarketId"
                                        placeholder="Geographical Market"
                                        clearable />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={6} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <FormGroup style={{ marginBottom: 5 }}>
                                    <EmployeesRangeCombo
                                        name="employeeAmount"
                                        placeholder="Employees"
                                        clearable />
                                </FormGroup>
                            </Col>
                            <Col md={6} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <FormGroup style={{ marginBottom: 5 }}>
                                    <Combo
                                        name="veteranServiceConnectedDisabled"
                                        placeholder="SDVS"
                                        items={{ "True": "SDVOB", "False": "VOB" }}
                                        clearable />
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12} style={{ paddingLeft: 5, paddingRight: 5 }}>
                                <FormGroup style={{ marginBottom: 5 }}>
                                    <BusinessCertificationMultiCombo
                                        name="businessCertificationCodes"
                                        placeholder="Business Certification(s)"
                                        clearable />
                                </FormGroup>
                            </Col>
                        </Row>
                    </Col>
                    <Col md={3} style={{ paddingLeft: 5, paddingRight: 5 }}>
                        <FormGroup style={{ marginBottom: 5 }}>
                            <AnnualSalesCombo
                                name="annualSalesTypeId"
                                placeholder="Search by Revenue"
                                clearable />
                        </FormGroup>
                        <FormGroup style={{ marginBottom: 5 }}>
                            <BusinessOwnershipMultiCombo
                                name="businessOwnershipIds"
                                placeholder="Business Ownership(s)"
                                clearable />
                        </FormGroup>
                    </Col>
                </Row>
            </React.Fragment >

        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/areas/sponsor/connectToVOB/Search.js